<template>
  <print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['department', 'com_name', 'rank', 'writer_name', 'date']"/>
    <!-- 보고서 개요 -->
    <div>
      <h5 class="my-4"><i class="dot"></i> 보고서 개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>학교명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.field_name }}</p>
          <field-selector v-else v-model="form.field_id" :field-name="form.field_name" class="w-full" @select="onSelectFieldSelector"/>
        </div>
        <div>
          <div>점검일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_3" />
        </div>
        <div>
          <div>위탁여부</div>
          <div class="flex-1">
            <vs-radio v-model="form.inputA_5" :disabled="board.readonly" vs-name="group2" vs-value="자체" class="mr-2">자체</vs-radio>
            <vs-radio v-model="form.inputA_5" :disabled="board.readonly" vs-name="group2" vs-value="위탁">위탁</vs-radio>
          </div>
        </div>
        <div v-if="form.inputA_5 === '위탁'">
          <div>위탁업체명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_8 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_8" />
        </div>
        <div>
          <div>위탁내용</div>
          <div class="flex">
            <vs-checkbox v-for="(item, index) in referContentList"
                         :vs-value="item.value"
                         :checked="form.inputA_6.indexOf(item.value) !== -1"
                         @change="onChangeReferContent">{{ item.text || item.value }}</vs-checkbox>
          </div>
        </div>
      </div>
    </div>
<!--    근로자 및 산업재해 현황-->
    <div>
      <h5 class="my-4"><i class="dot"></i> 근로자 및 산업재해 현황</h5>
      <span style="font-weight: 700;">현업근로자</span>
      <div class="writeGridContainer">
        <div>
          <div>조리</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div>
          <div>시설관리</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" />
        </div>
        <div>
          <div>청소</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_3" />
        </div>
        <div>
          <div>통학차량보조</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>
      </div>

      <span style="font-weight: 700;">도급종사자</span>
      <div class="writeGridContainer">
        <div>
          <div>조리</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_1" />
        </div>
        <div>
          <div>시설관리</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_2" />
        </div>
        <div>
          <div>청소</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_3" />
        </div>
        <div>
          <div>통학차량보조</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_4" />
        </div>
      </div>

      <span style="font-weight: 700;">전년도</span>
      <div class="writeGridContainer">
        <div>
          <div>사망</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputD_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_1" />
        </div>
        <div>
          <div>부상</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputD_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_2" />
        </div>
        <div>
          <div>질병</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputD_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_3" />
        </div>
      </div>

      <span style="font-weight: 700;">당해년도</span>
      <div class="writeGridContainer">
        <div>
          <div>사망</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputE_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputE_1" />
        </div>
        <div>
          <div>부상</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputE_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputE_2" />
        </div>
        <div>
          <div>질병</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputE_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputE_3" />
        </div>
      </div>
    </div>

<!--    최근 3년이내 산업재해 발생 여부-->
    <div>
      <h5 class="my-4"><i class="dot"></i> 최근 3년이내 산업재해 발생 여부</h5>
      <div class="mt-8" :style="form.inputF_0 === '해당없음'? 'margin-bottom:20px': ''">
        <vs-radio v-model="form.inputF_0" :disabled="board.readonly" vs-name="group1" vs-value="해당있음" class="mr-2">해당있음</vs-radio>
        <vs-radio v-model="form.inputF_0" :disabled="board.readonly" vs-name="group1" vs-value="해당없음" class="mr-2">해당없음</vs-radio>
      </div>
      <div v-if="form.inputF_0 === '해당있음'" class="writeGridContainer">
        <div>
          <div>발생일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputF_1 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputF_1" />
        </div>
        <div>
          <div>직종</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputF_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputF_2" />
        </div>
        <div>
          <div>재해유형</div>
          <p v-if="isPrint" class=" print-input flex-1">{{ form.inputF_3 }}</p>
          <disaster-class-selector
            v-else
            class="w-full flex-1"
            :readonly="board.readonly"
            v-model="form.inputF_3"
          />
        </div>

        <div class="items-start" style="line-height: 2.5">
          <div>상해종류</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputF_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputF_4" />
        </div>
        <div class="writeGridLineItem items-start">
          <div>발생개요</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputF_5 }}</p>
          <ml-textarea v-else :readonly="board.readonly" v-model="form.inputF_5" />
        </div>
      </div>
    </div>

    <div>
      <h5 class="my-4"><i class="dot"></i> 점검결과 총평</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>주요 지도사항</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputG_1 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputG_1" :readonly="board.readonly" :max="5000" />
        </div>
      </div>
    </div>

    <!-- 점검표 -->
    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="점검표"
      :table-header-title="'점검사항'"
      :table-header-check="[{ text: '적정' }, { text: '미흡' }, { text: '해당없음' }]"
      :tableHeaderNote="[{ text: '비고' },]"
      contentBefore="•"
      v-model="form.inspectList"
      class="mt-5"
    >
      <template #customType="{ trData, id, input }">
        <div v-if="trData && trData.customType === '1'" class="p-2">
          <div class="flex justify-between items-center">
            <span>실시일</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input1 }}</p>
            <date-selector v-else :readonly="board.readonly" v-model="trData.input1" style="min-width: 200px;"/>
          </div>
          <div class="flex justify-between items-center mt-1">
            <span>실시일</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input2 }}</p>
            <date-selector v-else :readonly="board.readonly" v-model="trData.input2" style="min-width: 200px;"/>
          </div>
        </div>
        <div v-else-if="trData && trData.customType === '2'" class="p-2">
          <div class="flex justify-between items-center">
            <span>교육대상</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input1 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="trData.input1" />
          </div>
          <div class="flex justify-between items-center mt-1">
            <span>실시인원</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input2 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="trData.input2" />
          </div>
        </div>
        <div v-else-if="trData && trData.customType === '3'" class="p-2">
          <div class="flex justify-between items-center mt-1">
            <span>실시일</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input1 }}</p>
            <date-selector v-else :readonly="board.readonly" v-model="trData.input1" style="min-width: 200px;"/>
          </div>
          <div class="flex justify-between items-center mt-1">
            <span>개선사항</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input2 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="trData.input2" />
          </div>
          <div class="flex justify-between items-center mt-1">
            <span>조치사항</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input3 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="trData.input3" />
          </div>
        </div>
      </template>
    </table-inspect-merge>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="관리적요인 개선조치 요구사항"
      :tableData="[
        { id: 'cell1', title: '개선조치 사항', type: 'textarea', placeholder: '내용' },
        { id: 'cell2', title: '구분', type: 'radio', placeholder: '내용', width: '280px',
          radioItems: [{value: '자체개선'}, {value: '조치보고'}]
        },
        { id: 'cell3', title: '비고', type: 'textarea', placeholder: '내용', width: '280px' },
      ]"
      v-model="form.requirementList"
    />


    <!-- 현장 유해위험요인 개선조치 -->
    <div>
      <h5 class="mt-4"><i class="dot"></i> 현장 유해위험요인 개선조치</h5>

      <div class="grid grid-cols-6 gap-x-6 gap-y-4 mt-4">
        <div v-for="_title in managementTitle" :key="_title" class="col-span-1 flex items-center">
          <div v-if="isPrint" class="flex items-center">
            <div v-if="form.managementChecked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">
              {{ _title }}
            </span>
          </div>
          <div v-else>
            <span class="flex">
              <vs-checkbox :readonly="board.readonly" v-model="form.managementChecked" :vs-value="_title">{{ _title }}</vs-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>

    <report-plan
      class="mt-5"
      v-for="(_title, _title_i) in managementTitle"
      :key="`management_${_title}`"
      v-show="form.managementChecked.includes(_title)"
      :section-title="_title"
      :reportPlan="form[`reportPlanList_${_title_i + 1}`]"
      :is-print="isPrint"
      :readonly="board.readonly"
      :is-show-title="true"
      :report-type="_title_i + 1"
    />

    <!-- 확인자 -->
<!--    <div v-if="!isPrint" class="mt-28px">-->
<!--      <div>-->
<!--        <h5><i class="dot"></i> 결재란</h5>-->
<!--      </div>-->
<!--      <div class="writeGridContainer mt-4" style="align-items: start">-->
<!--        <div>-->
<!--          <div>작성자</div>-->
<!--          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />-->
<!--          <span v-else class="print-input">{{ form.sign1.name }}</span>-->
<!--        </div>-->
<!--        <div style="align-items: start">-->
<!--          <div class="pt-2">서명</div>-->
<!--          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />-->
<!--          <div v-else class="w-full flex-1 p-1">-->
<!--            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />-->
<!--            <div v-else class="signatureImg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="writeGridContainer mt-4" style="align-items: start">-->
<!--        <div>-->
<!--          <div>검토자</div>-->
<!--          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />-->
<!--          <span v-else class="print-input">{{ form.sign2.name }}</span>-->
<!--        </div>-->
<!--        <div style="align-items: start">-->
<!--          <div class="pt-2">서명</div>-->
<!--          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />-->
<!--          <div v-else class="w-full flex-1 p-1">-->
<!--            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />-->
<!--            <div v-else class="signatureImg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="writeGridContainer mt-4" style="align-items: start">-->
<!--        <div>-->
<!--          <div>회람자</div>-->
<!--          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />-->
<!--          <span v-else class="print-input">{{ form.sign3.name }}</span>-->
<!--        </div>-->
<!--        <div style="align-items: start">-->
<!--          <div class="pt-2">서명</div>-->
<!--          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign3.sign" class="w-full flex-1 p-1" />-->
<!--          <div v-else class="w-full flex-1 p-1">-->
<!--            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />-->
<!--            <div v-else class="signatureImg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="writeGridContainer mt-4" style="align-items: start">-->
<!--        <div>-->
<!--          <div>승인자</div>-->
<!--          <ml-input v-if="!isPrint" v-model="form.sign4.name" :readonly="board.readonly" />-->
<!--          <span v-else class="print-input">{{ form.sign4.name }}</span>-->
<!--        </div>-->
<!--        <div style="align-items: start">-->
<!--          <div class="pt-2">서명</div>-->
<!--          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign4.sign" class="w-full flex-1 p-1" />-->
<!--          <div v-else class="w-full flex-1 p-1">-->
<!--            <img v-if="form.sign4.sign" :src="form.sign4.sign" width="100%" alt="Signature" class="signatureImg" />-->
<!--            <div v-else class="signatureImg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!--    사진대지-->
<!--    <photo-upload-grid-module-->
<!--      :row-count="2"-->
<!--      :grid-count="2"-->
<!--      v-model="form.photoList"-->
<!--      :is-print="isPrint"-->
<!--      :readonly="board.readonly"-->
<!--      section-title="사진대지"-->
<!--      placeholder="신축현장 점검"-->
<!--    />-->

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import * as inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import Print from "@/views/boards/single-page/669/Print.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import ReportPlan from "@/views/boards/single-page/669/ReportPlan.vue";

export default {
  components: {
    ReportPlan,
    FieldSelector,
    Print,
    TableCustom,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      managementTitle: ["조치보고", "자체개선", "우수사례"],
      referContentList: [
        { value: "월점검", text: "월점검" },
        { value: "위험성평가", text: "위험성평가" },
        { value: "근골격계조사", text: "근골격계조사" },
      ],
      form: {
        stdInfo: {},
        field_id: "",
        field_name: "",

        inputA_2: "",
        inputA_3: "",
        inputA_5: "",
        inputA_6: [],
        inputA_8: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",

        inputE_1: "",
        inputE_2: "",
        inputE_3: "",

        inputF_0: "해당있음",
        inputF_1: "",
        inputF_2: "",
        inputF_3: "",
        inputF_4: "",
        inputF_5: "",

        inputG_1: "",

        inspectList: inspectData.inspectTable,
        requirementList: [ { "id": 1, "cell1": "", "cell2": "" } ],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
        photoList: [],
        fileList: [],
        managementChecked: [],
        reportPlanList_1: [],
        reportPlanList_2: [],
        reportPlanList_3: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.field_name = value.field_name;
    },
    onChangeReferContent(value) {
      const index = this.form.inputA_6.indexOf(value);
      if (index === -1) {
        this.form.inputA_6.push(value);
      } else {
        this.form.inputA_6.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
